export const APP_VERSION='v2.1.34'
export const INV_LIST_REQ_BEGIN_DATE = '01-01-1900';
export const INV_LIST_REQ_END_DATE = '01-01-9999';
export const SUCCESS = 'Success';
export const MULTI_CURRENCY_LENGTH = 0;
export const REASON_CODE = 'PP';
